import React, { useEffect, useState } from "react";
import CreatableSelect from 'react-select/creatable';
import Nouislider from "nouislider-react";
import {
  Container,
  Card,
  CardBody,
  Col,
  Row,
  Label,
  Input,
  Form,
  Button,
  UncontrolledPopover, 
  PopoverHeader, 
  PopoverBody
} from "reactstrap";

import { useSelector } from "react-redux";
import { get_Bot_Categories, get_Models } from "../../helpers/fakebackend_helper";
import { useDispatch } from "react-redux";
import { Get_Create_Bot_Model_List, GET_DB_Connection_for_bot_config, Get_Plan_Allowed_Features, update_bot_details } from "../../slices/thunks";
import Loader from "../../Components/Common/Loader";
import moment from "moment";
import { convertGmtToUserLocal, convertISODateToUserLocal, convertUTCToLocal } from "../../slices/layouts/utils";
import { Temperature_Modal } from "../../Components/Common/CustomModal/Temperature_Modal";
import { Top_p_Modal } from "../../Components/Common/CustomModal/Top_P_Modal";
import { Type_Of_Bot_Modal } from "../../Components/Common/CustomModal/Type_Of_Bot_Modal";
import { Model_Type_modal } from "../../Components/Common/CustomModal/Model_Type_modal";
import { Max_Record_MOdal } from "../../Components/Common/CustomModal/Max_Record_MOdal";
import VectorDBChunkCount from "../../Components/Common/VectorDBChunkCount";
import Vector_Search_ScoreThreshold from "../../Components/Common/Vector_Search_ScoreThreshold";
import { bool, boolean } from "yup";
// import SidebarCust from '../../Layouts/SidebarCust';

const Configuration = ({_profile_image_file}) => {
  document.title = "BotSetting | Configuration";
  const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
  const { loading , Database_Details_For_Bot } = useSelector((state) => state.BotDetails);
  const dispatch = useDispatch()

  const {
    Assets_ID,
    BOT_Category,
    Bot_Allow_See_Source,
    Bot_Description,
    Bot_ID,
    Bot_Instructions,
    Bot_Sample_Question,
    Bot_Title,
    Database_ID,
    Files_Path,
    Group_ID,
    Group_Name,
    Last_Active_Date_Time,
    Last_Updated_By,
    Last_Updated_Date,
    Max_Record,
    Model,
    Status,
    Type,
    User_Name,
    User_Role,
    Bot_Logo,
    top_p,
    temperature,
    SQL_Instruction,
    Query_Model,
    vector_chunk_count,
    Embedding_Model,
    send_sql_to_llm,
  } = BotDetails;

  const handleChange = (setter) => (event) => {

    setter(event.target.value);
  };
  const [_send_sql_to_llm, set_send_sql_to_llm] = useState(send_sql_to_llm)
  const [_Assets_ID, set_Assets_ID] = useState(Assets_ID);
  const [_BOT_Category, set_BOT_Category] = useState(BOT_Category);
  const [_Bot_Allow_See_Source, set_Bot_Allow_See_Source] =
    useState(Bot_Allow_See_Source);
  const [_Bot_Description, set_Bot_Description] = useState(Bot_Description);
  const [_SQL_Instruction, set_SQL_Instruction] = useState("");

  const [_Bot_ID, set_Bot_ID] = useState(Bot_ID);
  const [_Bot_Instructions, set_Bot_Instructions] = useState(Bot_Instructions);
  const [_Bot_Sample_Question, set_Bot_Sample_Question] =
    useState(Bot_Sample_Question);
  const [_Bot_Title, set_Bot_Title] = useState(Bot_Title);
  const [_Database_ID, set_Database_ID] = useState(Database_ID);
  const [_Files_Path, set_Files_Path] = useState(Files_Path);
  const [_Group_ID, set_Group_ID] = useState(Group_ID);
  const [_Group_Name, set_Group_Name] = useState(Group_Name);
  const [_Last_Active_Date_Time, set_Last_Active_Date_Time] = useState(
    Last_Active_Date_Time
  );
  const [_Last_Updated_By, set_Last_Updated_By] = useState(Last_Updated_By);
  const [_Last_Updated_Date, set_Last_Updated_Date] =
    useState(Last_Updated_Date);
  const [_Max_Record, set_Max_Record] = useState(Max_Record);
  const [_Model, set_Model] = useState(Model);
  const [_Status, set_Status] = useState(Status);
  const [_Type, set_Type] = useState(Type);
  const [_User_Name, set_User_Name] = useState(User_Name);
  const [_User_Role, set_User_Role] = useState(User_Role);

  const [model_list, setmodel_list] = useState([]);
  const [bot_category_list, setbot_category_list] = useState([])
  const [_Query_Model, setQuery_Model] = useState('')
  const [_vector_chunk_count, set_vector_chunk_count] = useState(vector_chunk_count)

  //Get Bot Model
  useEffect(() => {
    set_Assets_ID(Assets_ID);
    set_BOT_Category(BOT_Category);
    set_Bot_Allow_See_Source(Bot_Allow_See_Source);
    set_Bot_Description(Bot_Description);
    set_Bot_ID(Bot_ID);
    set_Bot_Instructions(Bot_Instructions);
    set_Bot_Sample_Question(Bot_Sample_Question);
    set_Bot_Title(Bot_Title);
    set_Database_ID(Database_ID);
    set_Files_Path(Files_Path);
    set_Group_ID(Group_ID);
    set_Group_Name(Group_Name);
    set_Last_Active_Date_Time(Last_Active_Date_Time);
    set_Last_Updated_By(Last_Updated_By);
    set_Last_Updated_Date(Last_Updated_Date);
    set_Max_Record(Max_Record);
    set_Model(Model);
    set_Status(Status);
    set_Type(Type);
    set_User_Name(User_Name);
    set_User_Role(User_Role);
    set_SQL_Instruction(SQL_Instruction);
    setQuery_Model(Query_Model)
    set_vector_chunk_count(vector_chunk_count)
    set_send_sql_to_llm((send_sql_to_llm==true||send_sql_to_llm==null)?true:false)
  }, [BotDetails]);

  //Get Model list
  useEffect(() => {
    get_Models()
      .then((response) => {
    
        setmodel_list(response);
      })
      .catch((error) => {
        console.log(error);
      });

      dispatch(Get_Create_Bot_Model_List())
  }, []);


  //Get Bot Categoty
  useEffect(() => {
    get_Bot_Categories().then((response) => {

         const category_options_temp = response.map((ele)=>{
            const {BOT_Category} = ele;
            return   { value: BOT_Category, label: BOT_Category }
         })

         setbot_category_list(category_options_temp)
    }).catch((error) => {
          console.log(error);
    })
  }, [])


  // useEffect(() => {
  //     if(Database_ID){
  //       dispatch(GET_DB_Connection_for_bot_config({ database_id:Database_ID}))
  //     }
  // }, [BotDetails])
  


  useEffect(() => {


    dispatch(Get_Plan_Allowed_Features())

  }, [])
  
  
  
  

  const onClickSave_BotConfig = () => {
      dispatch(update_bot_details({
        Bot_ID:Bot_ID,
        Group_ID:Group_ID,
        Database_ID:Database_ID,
        assets_id:_Assets_ID,
 new_model:_Model,
 number_of_rows:_Max_Record, 
 BOT_Category:_BOT_Category,
  title:_Bot_Title,
  description:_Bot_Description,
  Bot_Sample_Question:_Bot_Sample_Question,
  model:_Model,
  instructions:_Bot_Instructions,
  bot_allow_see_source:false ,
  bot_logo:_profile_image_file ,
  temperature:temp_mincost,
  top_p:top_mincost,
  SQL_Instruction:_SQL_Instruction,
  Query_Model:_Query_Model,
  vector_chunk_count:_vector_chunk_count,
  send_sql_to_llm:_send_sql_to_llm
      }))
    
    

  }

  const [temp_mincost, temp_setMincost] = useState(temperature !== null || top !== undefined ? temperature : 1);
  const [temp_maxcost, temp_setMaxcost] = useState(1);
  //slider function
  const temp_onUpDate = (value) => {
    // console.log(value);
    temp_setMincost(value[0]);
    temp_setMaxcost(value[1]);
  };

  useEffect(() => {
    temp_onUpDate([temp_mincost, temp_maxcost]);
  }, [temp_mincost, temp_maxcost]);

  
  const [top_mincost, top_setMincost] = useState(top_p !== null || top !== undefined? top_p : 1);
  const [top_maxcost, top_setMaxcost] = useState(1);
  //slider function
  const top_onUpDate = (value) => {
    top_setMincost(value[0]);
    top_setMaxcost(value[1]);
  };

  useEffect(() => {
    top_onUpDate([top_mincost, top_maxcost]);

  }, [top_mincost, top_maxcost]);


  useEffect(() => {
    top_setMincost(top_p !== null || top !== undefined? top_p : 1)
    temp_setMincost(temperature !== null || top !== undefined ? temperature : 1)
  }, [BotDetails])
 
  //testing
  const groupedModels = model_list.reduce((acc, model) => {
    const { Provider, ModelVersion, ModelID } = model;
    
    // Find if the provider already exists in acc
    let group = acc.find(g => g.label === Provider);
    
    if (!group) {
      group = { label: Provider, options: [] };
      acc.push(group);
    }
  
    // Add model version under the provider
    group.options.push({ value: ModelID, label: ModelVersion });
  
    return acc;
  }, []);

      const {  Model_List , Embedding_Model_List   }  = useSelector((state)=>state.Create_Bot)
  
  
  return (
    <div className="configuraion_form">
      <Row>
        <Col>
          <div className="bot_cancel_save d-flex">
            <div className="b_Admin">
              {/* <span class="rounded-pill badge bg-secondary-subtle text-secondary f-14">{User_Role}</span> */}
              <span style={{padding: '1px 8px'}} className={`rounded-pill ${User_Role === 'BotUser' ? 'bg-warning-cust text-dark' :
                                                User_Role === 'Viewer' ? 'bg-info-subtle-cust text-dark' :
                                                User_Role === 'BotAdmin' ? 'bg-primary-cust-button text-dark' :
                                                'btn-outline-primary'
                                              }`}>{User_Role}</span>
              {/* <p className="text_muted mt-10">
                  Trained, Created by {User_Name} at {convertUTCToLocal(Last_Updated_Date)}
                </p> */}
            </div>
            <div className="cancel_save">
              {/* <Button color="light" className="rounded-pill">
                Cancel
              </Button> */}
              { (User_Role !=='BotUser' && User_Role !=='Viewer' ) && <Button onClick={onClickSave_BotConfig} >
                Save
              </Button>}
            </div>
          </div>
          <p className="text_muted mt-10">Trained, Created by {User_Name} at {convertUTCToLocal(Last_Updated_Date)}</p>
        </Col>
      </Row>
      <Card>
        {<CardBody>
          {loading? <Loader/>: <><Row>
            {(_Type === "General" || _Type === "DBLink") && (
            <>
              <Col md={12}>
                  <div className="mt-4">

                      <Label htmlFor="llm_model" className="form-label">
                          Response Model * <Model_Type_modal />
                      </Label>
                      {/* <select
                          disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                          className="form-select mb-3"
                          aria-label="Default select example"
                          onChange={handleChange(set_Model)}
                      >
                          {model_list.map((ele, i) => {
                              return (
                                  <option key={ele.ModelID} selected={_Model === ele.ModelVersion} value={ele.ModelVersion}>{ele.ModelVersion}</option>
                              );
                          })}
                      </select> */}
                      <select
                        disabled={User_Role === "BotUser" || User_Role === "Viewer"}
                        className="form-select mb-3"
                        aria-label="Default select example"
                        onChange={handleChange(set_Model)}
                      >
                        {groupedModels.map((group, i) => (
                          <optgroup key={i} label={group.label}>
                            {group.options.map((ele) => (
                              <option selected={_Model === ele.label}  key={ele.value} value={ele.label}>
                                {ele.label}
                              </option>
                            ))}
                          </optgroup>
                        ))}
                      </select>
                  </div>
              </Col>

              {_Type === "DBLink" && (
                <Col md={12}>
                <div className="mt-4">

                    <Label htmlFor="llm_model" className="form-label">
                        SQL Model * <Model_Type_modal />
                    </Label>
                    <select
                      disabled={User_Role === "BotUser" || User_Role === "Viewer"}
                      className="form-select mb-3"
                      aria-label="Default select example"
                      onChange={handleChange(setQuery_Model)}
                    >
                      {groupedModels.map((group, i) => (
                        <optgroup key={i} label={group.label}>
                          {group.options.map((ele) => (
                            <option selected={_Query_Model === ele.label}  key={ele.value} value={ele.label}>
                              {ele.label}
                            </option>
                          ))}
                        </optgroup>
                      ))}
                    </select>
                </div>
            </Col>
              )}
            </>
          )}
                      {/* <Col>
                          <div className="mt-4">

                              <Label htmlFor="llm_model" className="form-label">
                                  Model * <Model_Type_modal />
                              </Label>
                              <select
                                 disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                                  className="form-select mb-3"
                                  aria-label="Default select example"
                                  onChange={handleChange(set_Model)}
                              >
                                  {model_list.map((ele, i) => {
                                      return (
                                          <option key={ele.ModelID} selected={_Model === ele.ModelVersion} value={ele.ModelVersion}>{ele.ModelVersion}</option>
                                      );
                                  })}
                              </select>
                              <select
                                disabled={User_Role === "BotUser" || User_Role === "Viewer"}
                                className="form-select mb-3"
                                aria-label="Default select example"
                                onChange={handleChange(set_Model)}
                              >
                                {groupedModels.map((group, i) => (
                                  <optgroup key={i} label={group.label}>
                                    {group.options.map((ele) => (
                                      <option selected={_Model === ele.label}  key={ele.value} value={ele.label}>
                                        {ele.label}
                                      </option>
                                    ))}
                                  </optgroup>
                                ))}
                              </select>
                          </div>
                      </Col> */}
                      <Col style={{}}>
                          <div className="mt-4">
                              <Form>
                                  <Label HtmlFor="temperature" className="form-label">
                                    Temperature <Temperature_Modal />
                                  </Label>
                                  {/* <UncontrolledPopover placement="right" target="PopoverDismissible" >
                                      <PopoverHeader> Dismissible popover </PopoverHeader>
                                      <PopoverBody> And here's some amazing content. It's very engaging. Right? </PopoverBody>
                                  </UncontrolledPopover> */}
                                  
                                  <div id="nonlinear" data-slider-color="secondary">
                                      <Nouislider
                                       disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                                          range={{
                                            min: 0,
                                            max: 2,
                                          }}
                                          start={[temperature]}
                                          connect
                                          onSlide={temp_onUpDate}
                                        />
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <div className="example-val" id="lower-value">{temp_mincost}</div>
                                    {/* <div className="example-val" id="upper-value"></div> */}
                                  </div>
                              </Form>
                          </div>
                      </Col>
                  </Row>
                  
                  <Row>
                          {Type === 'DBLink' && <Col xxl={12} md={12}>
                              <div className="mt-4">
                                  <Label htmlFor="max_record" className="form-label">
                                      Max Record * <Max_Record_MOdal />
                                  </Label>
                                  <Input
                                      disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                                      onChange={handleChange(set_Max_Record)}
                                      value={_Max_Record}
                                      type="text"
                                      className="form-control"
                                      id="max_record" />
                              </div>
                          </Col>}
                          {/* <Col xxl={6} md={6}>
                                <div className="mt-4">
                                  <Label htmlFor="basiInput" className="form-label">
                                      Permission to view source 
                                  </Label>
                                  <div className="mt-4 mt-lg-0">
                                      <div className="form-check form-check-inline">
                                          <Input
                                          disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                                              className="form-check-input"
                                              type="radio"
                                              name="Permission_to_view_source"
                                              id="inlineRadio1"
                                              value="option1" />
                                          <Label className="form-check-label" htmlFor="inlineRadio1">
                                              Yes
                                          </Label>
                                      </div>
                                      <div className="form-check form-check-inline">
                                          <Input
                                          disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                                              className="form-check-input"
                                              type="radio"
                                              name="Permission_to_view_source"
                                              id="inlineRadio1"
                                              value="option2" />
                                          <Label className="form-check-label" htmlFor="inlineRadio">
                                              No
                                          </Label>
                                      </div>
                                      
                                  </div>
                              </div>
                          </Col> */}
                          {/* <div className="form-check form-check-inline">
                                                  <Input className="form-check-input" type="radio" name="inlineRadioOptions" id="WithoutinlineRadio1" value="option1" />
                                              </div> */}
                          <Col style={{}}>
                          <div className="mt-4">
                              <Form>
                                  <Label HtmlFor="temperature" className="form-label">
                                    Top P <Top_p_Modal />
                                  </Label>
                                  {/* <input type="range" className="form-range" id="temperature" /> */}
                                  <div id="nonlinear" data-slider-color="secondary">
                                      <Nouislider
                                          disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                                          range={{
                                            min: 0.01,
                                            max: 1,
                                          }}
                                          start={[top_p]}
                                          connect
                                          onSlide={top_onUpDate}
                                        />
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <div className="example-val" id="lower-value">{top_mincost}</div>
                                    {/* <div className="example-val" id="upper-value"></div> */}
                                  </div>
                              </Form>
                          </div>
                      </Col>
                      </Row>
                      <Row>
                        <Col lg={12}>
                          <div className="mt-4">

                              <Label htmlFor="llm_model" className="form-label">
                              Vector Embedding Models 
                              </Label>
                               <select disabled={true}
                                                                      onChange={(e) => dispatch(create_set_Embedding_Model(e.target.value))}
                                                                      className="form-select"
                                                                      aria-label=".form-select-sm example"
                                                                  >
                                                                      {Object.entries(
                                                                      Embedding_Model_List.reduce((acc, ele) => {
                                                                          if (!acc[ele.EmdProvider]) acc[ele.EmdProvider] = [];
                                                                          acc[ele.EmdProvider].push(ele);
                                                                          return acc;
                                                                      }, {})
                                                                      ).map(([EmdProvider, models]) => (
                                                                      <optgroup label={EmdProvider} key={EmdProvider}>
                                                                          {models.map((ele) => (
                                                                          <option 
                                                                              selected={ele.EmdModelVersion === Embedding_Model} 
                                                                              value={ele.EmdModelVersion} 
                                                                              key={ele.EmdModelID}
                                                                          >
                                                                              {ele.EmdModelVersion}
                                                                          </option>
                                                                          ))}
                                                                      </optgroup>
                                                                      ))}
                                                                  </select>
                          </div>
                      </Col>
                      {Database_ID && <Col lg={12}>
                          <div className="mt-4">

                              <Label htmlFor="Db_Connection" className="form-label">
                              DB Connection
                              </Label>
                              <Input
                                      disabled={true}
                                      value={Database_Details_For_Bot?.connection?.Connection_Name}
                                      type="text"
                                      className="form-control"
                                      id="Db_Connection" />
                 
                          </div>
                      </Col>}
                  </Row>
                      <Row>
                        <Col>
                        {/* <Col xxl={6} md={6}> */}
                          <VectorDBChunkCount set_vector_chunk_count={set_vector_chunk_count} _vector_chunk_count={_vector_chunk_count}  />
                        </Col>
                        {/* <Col xxl={6} md={6}>
                          <Vector_Search_ScoreThreshold />
                        </Col> */}
                      </Row>
                      <Row>
                          <Col xxl={12} md={12}>
                              <div className="mt-4">
                                  <Label htmlFor="type" className="form-label">
                                    Bot Type <Type_Of_Bot_Modal />
                                  </Label>
                                  <Input
                                      disabled={true}
                                      onChange={handleChange(set_Type)}
                                      value={_Type}
                                      type="text"
                                      className="form-control"
                                      id="type" />
                              </div>
                          </Col>
                          <Col xxl={12} md={12}>
                              <div className="mt-4">
                                  <Label htmlFor="category" className="form-label">
                                      Category 
                                  </Label>
                                  {/* <Input
                                      onChange={handleChange(set_BOT_Category)}
                                      value={_BOT_Category}
                                      type="text"
                                      className="form-control"
                                      id="category" /> */}
                                      <CreatableSelect 
                                      required={false}
                                      isDisabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                                      placeholder="Create or Select"
                                      onChange={(value)=>{
                                   
                                        
                                        
                                          set_BOT_Category(value.value);
                                      }} defaultInputValue={ _BOT_Category|| BOT_Category} options={bot_category_list} />
                              </div>
                          </Col>
                          {Type.toLowerCase() == 'dblink' && <Col xxl={12} md={12}>
                          <div className="mt-4">
                           <Label>Send Query Result To LLM</Label>
                           </div>
                              <div className="form-check form-check-inline">
                                  <Input onChange={(e)=>{
                                    console.log(e.target.value)
                                    set_send_sql_to_llm(Boolean(e.target.value))
                                  }} checked={_send_sql_to_llm} className="form-check-input" type="radio" name="inlineRadioOptions1" id="inlineRadio1" value="true"></Input>
                                  <label className="form-check-label" htmlFor="inlineRadio1">Yes</label>
                              </div>
                              <div  className="form-check form-check-inline">
                                  <Input onChange={(e)=>{
                                    console.log(!Boolean(e.target.value))
                                    set_send_sql_to_llm(!Boolean(e.target.value))
                                  }}  checked={!_send_sql_to_llm} className="form-check-input" type="radio" name="inlineRadioOptions2" id="inlineRadio2" value="false"></Input>
                                  <label className="form-check-label" htmlFor="inlineRadio2">No</label>
                              </div>
                          </Col>}
                      </Row>
                      <Row>
                          {/* <Col xxl={12} md={12}>
                              <div className="mt-4">
                                  <Label htmlFor="type" className="form-label">
                                      Bot description
                                  </Label>
                                  <textarea
                                  disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                                      onChange={handleChange(set_Bot_Description)}
                                      value={_Bot_Description}
                                      className="form-control"
                                      id="botdescription"
                                      rows="3"
                                      placeholder="Enter your message"
                                  ></textarea>
                              </div>
                          </Col> */}
                          <Col xxl={12} md={12}>
                              {/* <div className="mt-4">
                                  <Label htmlFor="category" className="form-label">
                                      Bot instruction
                                  </Label>
                                  <textarea
                                      disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                                      onChange={handleChange(set_Bot_Instructions)}
                                      value={_Bot_Instructions}
                                      className="form-control"
                                      id="botinstruction"
                                      rows="3"
                                      placeholder="Enter your message"
                                  ></textarea>
                              </div> */}
                              {/* {_Type === "DBLink" && (
                                  <div className="mt-4">
                                    <Label htmlFor="category" className="form-label">
                                        Sql instruction
                                    </Label>
                                    <textarea
                                        disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}                                     
                                        className="form-control"
                                        onChange={handleChange(set_SQL_Instruction)}
                                        value={_SQL_Instruction}
                                        id="SQLinstruction"
                                        rows="3"
                                        placeholder="Enter your message"
                                    ></textarea>
                                </div>
                                )} */}
                              
                          </Col>
                          <Col xxl={12} md={12}>
                              {/* <div className="mt-4">
                                  <Label htmlFor="category" className="form-label">
                                      Sample question
                                  </Label>
                                  <textarea
                                  disabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                                      onChange={handleChange(set_Bot_Sample_Question)}
                                      value={_Bot_Sample_Question}
                                      className="form-control"
                                      id="samplequestion"
                                      rows="3"
                                      placeholder="Enter your message"
                                  ></textarea>
                              </div> */}
                          </Col>
                      </Row></>}
        </CardBody>}
      </Card>
    </div>
  );
};

export default Configuration;
